import { Stack } from "@mui/material";
// import Skeleton from "react-loading-skeleton";
import { Skeleton } from "@mui/material";

export default function VideoThumbnailSkeleton() {
  return (
    <Stack flexDirection="column">
      <Skeleton variant="rounded" width={150} height={70} />
      <Skeleton width={150} />
      <Skeleton width={70} />
    </Stack>
  );
}
